
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  troughFilterButton: {
    id: "TroughFilterButton.button",
    defaultMessage: "Deselect",
  },
  filterExosError: {
    id: "TroughFilterExos.error",
    defaultMessage: "EXOS. is required.",
  },
  filterExosLabel: {
    id: "TroughFilterExos.label",
    defaultMessage: "EXOS",
  },
  filterVariusError: {
    id: "TroughFilterVarius.error",
    defaultMessage: "VARIUSsign is required.",
  },
  filterVariusLabel: {
    id: "TroughFilterVarius.label",
    defaultMessage: "VARIUSsign",
  },
  filterVariusmedError: {
    id: "TroughFilterVariusmed.error",
    defaultMessage: "VARIUSmed is required.",
  },
  filterVariusmedLabel: {
    id: "TroughFilterVariusmed.label",
    defaultMessage: "VARIUSmed",
  },
  filterMedcareError: {
    id: "TroughFilterMedcare.error",
    defaultMessage: "MEDCARE is required.",
  },
  filterMedcareLabel: {
    id: "TroughFilterMedcare.label",
    defaultMessage: "MEDCARE",
  },
  filterSquareError: {
    id: "TroughFilterSquare.error",
    defaultMessage: "Square is required.",
  },
  filterSquareLabel: {
    id: "TroughFilterSquare.label",
    defaultMessage: "Square",
  },
  filterOvalError: {
    id: "TroughFilterOval.error",
    defaultMessage: "Oval is required.",
  },
  filterOvalLabel: {
    id: "TroughFilterOval.label",
    defaultMessage: "Oval",
  },
  filterRoundError: {
    id: "TroughFilterRound.error",
    defaultMessage: "Round is required.",
  },
  filterRoundLabel: {
    id: "TroughFilterRound.label",
    defaultMessage: "Round",
  },
  filterWithOverflowError: {
    id: "TroughFilterWithOverflow.error",
    defaultMessage: "With overflow is required.",
  },
  filterWithOverflowLabel: {
    id: "TroughFilterWithOverflow.label",
    defaultMessage: "With overflow",
  },
  filterWithoutOverflowError: {
    id: "TroughFilterWithoutOverflow.error",
    defaultMessage: "Without overflow is required.",
  },
  filterWithoutOverflowLabel: {
    id: "TroughFilterWithoutOverflow.label",
    defaultMessage: "Without overflow",
  },
  filterWithBackwallError: {
    id: "TroughFilterWithBackwall.error",
    defaultMessage: "With prepared backwall is required.",
  },
  filterWithBackwallLabel: {
    id: "TroughFilterWithBackwall.label",
    defaultMessage: "With backwall",
  },
  filterWithoutBackwallError: {
    id: "TroughFilterWithoutBackwall.error",
    defaultMessage: "Without backwall is required.",
  },
  modelLine: {
    id: "TroughFilter.modelLine",
    defaultMessage: "Model line",
  },
  characteristics: {
    id: "TroughFilter.characteristics",
    defaultMessage: "Characteristics",
  },
});

export default MESSAGES;